import React from "react";
import Table from "./Table";
import New from "./New";

function Fleets() {
  return (
    <div>
      <h2>
        Fleet
        <New />
      </h2>
      <Table />
    </div>
  );
}

export default Fleets;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Fleets/Fleets.jsx